import { withNamespaces } from "react-i18next";
import { Badge, Button } from "reactstrap";

import "./style.scss";

const normalizeObligations = (obligations, obligation) => {
    if (Array.isArray(obligations)) {
        return obligations.filter(Boolean);
    }

    if (obligation) {
        return [obligation];
    }

    return [];
};

const ObligationItem = ({ obligation, t, showDivider, onAddDocument }) => {
    const {
        gap_reason: gapReason,
        required_document: requiredDocument,
        blocking = false
    } = obligation;

    const isBlocking = blocking === true;

    return (
        <div
            className={`compliance-gap-notice__item ${
                showDivider ? "compliance-gap-notice__item--divided" : ""
            }`}
        >
            <div className="compliance-gap-notice__item-text">
                <div className="compliance-gap-notice__badges">
                    <Badge className="compliance-gap-notice__badge">
                        {t("Documentation gap")}
                    </Badge>

                    {isBlocking && (
                        <Badge color="danger" className="bg-danger" pill>
                            {t("Critical Requirement")}
                        </Badge>
                    )}
                </div>

                {gapReason && (
                    <div className="compliance-gap-notice__reason">
                        {gapReason}
                    </div>
                )}

                {requiredDocument && (
                    <div className="compliance-gap-notice__document">
                        <span className="fw-medium">
                            {t("Required document")}
                            {": "}
                        </span>
                        {requiredDocument}
                    </div>
                )}
            </div>

            {onAddDocument && (
                <Button
                    color="warning"
                    outline
                    size="sm"
                    className="compliance-gap-notice__action"
                    onClick={() => onAddDocument(obligation)}
                >
                    <i className="ri-add-line me-1" />
                    {t("Add supporting document")}
                </Button>
            )}
        </div>
    );
};

/**
 * Renders EU AI Act compliance gap notices for a questionnaire question.
 * Presentation only — no lookup, fetch, or business logic.
 *
 * @param {Object} props
 * @param {Array<Object>} [props.obligations]
 * @param {Object} [props.obligation] Legacy single-obligation prop
 * @param {Function} [props.onAddDocument] Shows the supporting-document action
 * @param {Function} props.t
 */
const ComplianceGapNotice = ({
    obligations,
    obligation,
    onAddDocument,
    t
}) => {
    const items = normalizeObligations(obligations, obligation);

    if (items.length === 0) {
        return null;
    }

    return (
        <div className="compliance-gap-notice" role="status">
            {items.map((item, index) => (
                <ObligationItem
                    key={item.code || `obligation-${index}`}
                    obligation={item}
                    t={t}
                    showDivider={index > 0}
                    onAddDocument={onAddDocument}
                />
            ))}
        </div>
    );
};

export default withNamespaces()(ComplianceGapNotice);
